import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import SelectDropdown from "../../components-react/SelectDropdown";
import { activeInactiveStatus } from "../../common-data/DropdowData";
import {
  addNewKeyword,
  updateKeyword,
} from "../../../redux/reducers/postApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";

const AddKeywordsForm = ({
  decryptedText,
  callKeyFunction,
  onCloseModal,
  isEdit,
  isCopy,
  editIniFormvalues,
}) => {
  const gymData = useSelector(selectGymData);
  const dispatch = useDispatch();

  const initialFormInputs = {
    predefinedMsg: "",
    tabName: "",
    sheetName: "",
    sheetId: "",
    status: activeInactiveStatus[0],
    isAddToLead: false,
    isAutoMapToGym: false,
    selectedGym: "",
  };
  const [formValues, setFormValues] = useState([
    isCopy || isEdit ? editIniFormvalues : initialFormInputs,
  ]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeFormValues1 = (index, e) => {
    setIsSubmit(false);
    const { name, value, checked, type } = e.target;
    const updatedFormValues = [...formValues];
    updatedFormValues[index][name] = type === "checkbox" ? checked : value;
    setFormValues(updatedFormValues);
  };
  const onChangeFormValues = (index, e) => {
    setIsSubmit(false);
    const { name, value, checked, type } = e.target;
    const updatedFormValues = [...formValues];

    updatedFormValues[index][name] = type === "checkbox" ? checked : value;

    if (name === "isAddToLead" && !checked) {
      updatedFormValues[index]["isAutoMapToGym"] = false;
    }

    setFormValues(updatedFormValues);
  };

  const onChangeDropdown = (index, name, selectedValue) => {
    setIsSubmit(false);
    const updatedFormValues = [...formValues];
    updatedFormValues[index][name] = selectedValue;
    setFormValues(updatedFormValues);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleAddForm = () => {
    setIsSubmit(false);
    setFormValues([...formValues, initialFormInputs]);
  };

  const handleRemoveForm = (index) => {
    setIsSubmit(false);
    const updatedFormValues = formValues.filter((_, i) => i !== index);
    setFormValues(updatedFormValues);
  };

  const handleCopyPreviousData = (index) => {
    if (index > 0) {
      const updatedFormValues = [...formValues];
      updatedFormValues[index] = { ...formValues[index - 1] };
      setFormValues(updatedFormValues);
    }
  };

  const validateForm = (formValues) => {
    let errors = formValues.map((formValue) => {
      let formErrors = {};

      if (!formValue.predefinedMsg) {
        formErrors.predefinedMsg = "Predefined Message Is Required!";
      } else if (formValue.predefinedMsg?.length > 100) {
        formErrors.predefinedMsg =
          "Predefined Message Length Can Not Be Greater Than 100 Characters!";
      }

      if (!formValue.sheetName) {
        formErrors.sheetName = "Sheet Name Is Required!";
      }

      if (!formValue.tabName) {
        formErrors.tabName = "Tab Name Is Required!";
      }

      if (!formValue.sheetId) {
        formErrors.sheetId = "Sheet ID Is Required!";
      }

      if (formValue.isAutoMapToGym && !formValue.selectedGym) {
        formErrors.selectedGym = "Gym Is Required!";
      }

      return formErrors;
    });

    const filteredErrors = errors.filter(
      (error) => Object.keys(error).length > 0
    );

    return filteredErrors.length > 0 ? errors : {};
  };

  const handleAddKeyword = async (userData, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult = dispatch(addNewKeyword({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Successfull!");
        setFormValues([initialFormInputs]);
        setFormErrors({});
        onCloseModal();
        callKeyFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Failed!");
      }
    } catch (error) {
      console.log("handleAddKeyword ERROR => ", error);
    }
  };

  const handleUpdateKeyword = async (userData, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult = dispatch(updateKeyword({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Successfull!");
        setFormValues([initialFormInputs]);
        setFormErrors({});
        onCloseModal();
        callKeyFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Failed!");
      }
    } catch (error) {
      console.log("handleUpdateKeyword ERROR => ", error);
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, []);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      setIsSubmit(false);

      if (isEdit) {
        const bodyData = {
          predefined_msg: formValues[0].predefinedMsg?.trim(),
          tab_name: formValues[0].tabName,
          sheet_name: formValues[0].sheetName,
          sheet_id: formValues[0].sheetId,
          status: formValues[0].status?.value,
          uid: formValues[0].uid,
          lead_capture: formValues[0].isAddToLead ? "true" : "false",
          auto_gym_map:
            formValues[0].isAddToLead && formValues[0].isAutoMapToGym ? 1 : 0,
          gym_id: formValues[0].selectedGym?.value,
        };

        const handleConfirm = () => {
          handleUpdateKeyword(bodyData, decryptedText?.token);
        };

        showConfirmAlert(
          handleConfirm,
          `Are you sure!`,
          "No, Edit Form",
          "Yes, Update"
        );
      } else {
        const bulkKeywordData = formValues.map((formValue) => ({
          predefined_msg: formValue.predefinedMsg?.trim() || "",
          tab_name: formValue.tabName || "",
          sheet_name: formValue.sheetName || "",
          sheet_id: formValue.sheetId || "",
          status:
            formValue.status?.value === "inactive"
              ? formValue.status.value
              : "active",
          lead_capture: formValue.isAddToLead ? "true" : "false",
          auto_gym_map:
            formValue.isAddToLead && formValue.isAutoMapToGym ? 1 : 0,
          gym_id: formValue.isAutoMapToGym
            ? formValue.selectedGym?.value || ""
            : "",
        }));

        const bodyData = {
          bulk_keyword_data: bulkKeywordData,
        };

        const handleConfirm = () => {
          handleAddKeyword(bodyData, decryptedText?.token);
        };

        showConfirmAlert(
          handleConfirm,
          `Are you sure!`,
          "No, Edit Form",
          "Yes, Add"
        );
      }
    }
  }, [isSubmit, formErrors]);

  // console.log("formErrors=> ", formErrors);
  console.log("formValues=> ", formValues);

  return (
    <form
      className="formContainer craeteIncentiveCategoryFormContainer"
      style={{ rowGap: "1rem" }}>
      {formValues.map((formValue, index) => (
        <React.Fragment key={index}>
          <div
            className="formInputsGrid"
            style={{ gridTemplateColumns: "repeat(2, 1fr)", gap: "1rem" }}>
            <div className="formInputBox span2">
              <label htmlFor="tabName" className="formInputLabel">
                Tab Name <span className="required">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Tab Name"
                className={`formInput ${
                  formErrors?.[index]?.tabName ? "formError" : ""
                }`}
                name="tabName"
                value={formValue.tabName}
                onChange={(e) => onChangeFormValues(index, e)}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="sheetName" className="formInputLabel">
                Sheet Name <span className="required">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Sheet Name"
                className={`formInput ${
                  formErrors?.[index]?.sheetName ? "formError" : ""
                }`}
                name="sheetName"
                value={formValue.sheetName}
                onChange={(e) => onChangeFormValues(index, e)}
              />
            </div>

            <div className="formInputBox span2">
              <label htmlFor="sheetId" className="formInputLabel">
                Sheet ID <span className="required">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Sheet ID"
                className={`formInput ${
                  formErrors?.[index]?.sheetId ? "formError" : ""
                }`}
                name="sheetId"
                value={formValue.sheetId}
                onChange={(e) => onChangeFormValues(index, e)}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="status" className="formInputLabel">
                Status
              </label>
              <div
                className={`commonWrapper ${
                  formErrors?.[index]?.status ? "formError" : ""
                }`}
                style={{ height: "60px" }}>
                <SelectDropdown
                  options={activeInactiveStatus}
                  selectedOption={formValue.status}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(index, "status", selectedValue)
                  }
                  name="status"
                />
              </div>
            </div>
          </div>

          <div
            className="formInputsGrid textareaGridContainer"
            style={{ gridTemplateColumns: "repeat(1, 1fr)" }}>
            <div className="formInputBox">
              <label htmlFor="predefinedMsg" className="formInputLabel">
                Predefined Message (Max 100 Characters -{" "}
                {formValue.predefinedMsg?.length}){" "}
                <span className="required">*</span>
              </label>
              <textarea
                name="predefinedMsg"
                className={`formInput ${
                  formErrors?.[index]?.predefinedMsg ? "formError" : ""
                }`}
                style={{ width: "100%" }}
                value={formValue.predefinedMsg}
                onChange={(e) => onChangeFormValues(index, e)}></textarea>
            </div>
          </div>

          <div className="formInputsGrid switchInputs twoGridSystem">
            {formValue.isAutoMapToGym && (
              <div className="formInputBox span2">
                <label htmlFor="selectedGym" className={`formInputLabel`}>
                  gym name <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.[index]?.selectedGym ? "formError" : ""
                  }`}
                  style={{ height: "60px" }}>
                  <SelectDropdown
                    options={gymData?.length > 0 ? gymData : []}
                    selectedOption={
                      formValues[index]?.selectedGym || formValues.selectedGym
                    }
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(index, "selectedGym", selectedValue)
                    }
                    name="Gym"
                  />
                </div>
              </div>
            )}

            <div className="formInputBox formInputSwitchBox">
              <div
                className={`commonWrapper commonSwitchWrapper no-border ${
                  formErrors?.isAddToLead ? "formError" : ""
                }`}>
                <Form.Check
                  type="switch"
                  name="isAddToLead"
                  label={`Add To Raw Lead`}
                  checked={formValue.isAddToLead}
                  onChange={(e) => onChangeFormValues(index, e)}
                />
              </div>
            </div>

            <div className="formInputBox formInputSwitchBox">
              <div
                className={`commonWrapper commonSwitchWrapper no-border ${
                  formErrors?.isAutoMapToGym ? "formError" : ""
                }`}>
                <Form.Check
                  type="switch"
                  name="isAutoMapToGym"
                  label={`Auto Map To Gym`}
                  checked={formValue.isAutoMapToGym}
                  onChange={(e) => onChangeFormValues(index, e)}
                  disabled={!formValue.isAddToLead}
                />
              </div>
            </div>
          </div>

          {index !== 0 && !isEdit ? (
            <div className="formButtons" style={{ justifyContent: "flex-end" }}>
              <Button
                className="external-btn"
                variant="danger"
                onClick={() => handleRemoveForm(index)}>
                - Remove
              </Button>
              <Button
                className="external-btn"
                variant="danger"
                onClick={() => handleCopyPreviousData(index)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-copy"
                  viewBox="0 0 16 16">
                  <path
                    fillRule="evenodd"
                    d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                  />
                </svg>
                Copy Previous Data
              </Button>
            </div>
          ) : null}
          <div className="grayLine"></div>
        </React.Fragment>
      ))}

      <div className="formButtons mt30" style={{ justifyContent: "flex-end" }}>
        {!isEdit && (
          <Button
            className="saveBtn external-btn"
            variant="danger"
            onClick={handleAddForm}>
            + Add More
          </Button>
        )}
        <Button className="saveBtn" variant="danger" onClick={handleSubmitForm}>
          {isEdit ? "Update" : "Submit"}
        </Button>
      </div>
    </form>
  );
};

export default AddKeywordsForm;
